<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.statusContratoId"
    item-text="statusContratoNome"
    item-name="statusContratoNome"
    item-value="statusContratoId"
    :items="statusContrato"
    label="Status de Contrato"
    placeholder="Status de Contrato"
    v-on:change="$emit('onChange')"
    :clearable = "true"
  >
    <template slot="no-data"> Nenhum Status de Contrato retornado </template>
  </v-select>
</template>

<script>
import { StatusContratoApi } from '../API/StatusContratoApi.js'

export default {
  name: 'AppStatusContratoCombobox',
  props: ['filter'],
  mounted () {
    this.loadStatus()
  },
  methods: {
    loadStatus () {
      StatusContratoApi.list()
        .then(resp => {
          this.statusContrato = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      statusContrato: []
    }
  }
}
</script>
